<template>
  <div class="job-page">
    <!-- 筛选栏 -->
    <div class="select-row">
      <div class="select-box">
        <el-select v-model="selectedSecond" placeholder="请选择企业" clearable>
          <el-option label="全部企业" value="" />
          <el-option
            v-for="item in secondOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <!-- 替换：岗位类型 → 工作地点 -->
      <!-- <div class="select-box">
        <el-select
          v-model="selectedLocation"
          placeholder="请选择工作地点"
          clearable
        >
          <el-option label="全部工作地点" value="" />
          <el-option
            v-for="item in locationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div> -->

      <div class="select-box">
        <el-select v-model="selectedEdu" placeholder="请选择学历要求" clearable>
          <el-option label="全部学历" value="" />
          <el-option
            v-for="item in eduOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <!-- 岗位列表：卡片点击跳转，详情合并折叠 -->
    <div class="job-list">
      <div
        class="job-item"
        v-for="job in filteredJobs"
        :key="job.id"
        @click="goLink(job.url)"
      >
        <div class="job-header">
          <!-- 左侧：岗位+企业 -->
          <div class="job-left">
            <div class="job-name">{{ job.name }}</div>
            <div class="job-company">
              {{ job.secondCompany }}
              <span v-if="job.third"> - {{ job.third }}</span>
            </div>
          </div>
          <!-- 右侧：报名按钮 -->
          <el-button
            class="apply-btn"
            type="primary"
            size="mini"
            icon="el-icon-user-add"
            @click.stop="goLink(job.url)"
          >
            报名入口
          </el-button>
        </div>

        <div class="job-info">
          <span class="info-item">📍 {{ job.location }}</span>
          <span class="info-item">📚 {{ job.education }}</span>
          <span class="info-item">👥 需求{{ job.needNum }}人</span>
          <span class="info-item">🏅 {{ job.jobType }}</span>
        </div>

        <!-- 合并：岗位描述 + 任职要求 + 薪酬，一起折叠 -->
        <div class="desc-block" @click.stop="toggleDetail(job.id)">
          <div class="desc-title">
            查看详情
            <i class="arrow" :class="{ open: openIds.includes(job.id) }"></i>
          </div>
          <div class="desc-content" v-show="openIds.includes(job.id)">
            <div class="sub-title">岗位描述：</div>
            {{ job.desc }}
            <div class="sub-title" style="margin-top: 8px">任职要求：</div>
            {{ job.requirement }}
          </div>
        </div>
      </div>

      <div class="empty" v-if="filteredJobs.length === 0">
        暂无匹配的招聘岗位
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabJob",
  data() {
    return {
      selectedSecond: "",
      selectedLocation: "",
      selectedEdu: "",
      openIds: [],
      secondOptions: [
        {
          label: "湖北水利发展集团有限公司",
          value: "湖北水利发展集团有限公司",
        },
        {
          label: "湖北水利发展集团十堰投资开发有限公司",
          value: "湖北水利发展集团十堰投资开发有限公司",
        },
        {
          label: "湖北瑞洪工程管理有限公司",
          value: "湖北瑞洪工程管理有限公司",
        },
        {
          label: "湖北水发汉江控股有限公司",
          value: "湖北水发汉江控股有限公司",
        },
        {
          label: "湖北禹航物产有限责任公司",
          value: "湖北禹航物产有限责任公司",
        },
        {
          label: "湖北楚禹水务科技有限公司",
          value: "湖北楚禹水务科技有限公司",
        },
      ],
      // // 新增：工作地点选项（基于现有岗位数据去重整理）
      // locationOptions: [
      //   { label: "武汉市", value: "武汉市" },
      //   { label: "宜昌市", value: "宜昌市" },
      //   { label: "荆州市", value: "荆州市" },
      //   { label: "襄阳市", value: "襄阳市" },
      //   { label: "宜城市", value: "宜城市" },
      //   { label: "湖北省内各项目经理部", value: "湖北省内各项目经理部" },
      //   { label: "国际船舶", value: "国际船舶" }
      // ],
      eduOptions: [
        { label: "本科", value: "本科" },
        { label: "硕士", value: "硕士" }
      ],
      jobList: [
        {
          id: 1,
          name: "科技创新部部长",
          secondCompany: "湖北水利发展集团有限公司",
          third: "",
          dept: "-",
          jobType: "集团中层正职级",
          needNum: 1,
          education: "硕士",
          desc: "1.统筹集团重点科技项目全生命周期管理，牵头对接政府主管部门，主导产学研合作与科技成果转化；\n2.负责集团数字化转型与信息化建设顶层设计，建立健全信息化管理体系，审定发展规划及制度规范；\n3.管控集团信息化项目全流程，审批重大项目立项与选型，监督项目实施，保障交付质量与成本控制；\n4.构建集团科技创新体系，审定中长期科技发展战略，制定科创、数字经济及网络安全管理制度与标准；\n5.主持科技创新部全面工作，负责团队建设、人才培养、预算管理、绩效考核及日常运营；\n6.指导各子公司科技创新领域工作；\n7.履行集团公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制硕士研究生及以上学历；\n2.年龄原则上不超过45周岁，身体健康，能够满足工作需要，博士或特别优秀的年龄可适当放宽；\n3.近3年年度考核结果为胜任（称职）及以上；\n4.具有10年以上信息化、科技创新、科研项目管理等相关工作经验，其中水利行业相关科技创新工作经验不少于3年；\n5.现任同级别党政机关、事业单位、科研院所、央国企中层正职等相当层级岗位，或中层副职等相当层级岗位任职2年以上，或累计5年以上中层副职及下一层级中层正职等相当层级岗位任职经历（中层副职任职经历不少于1年）；\n6.熟悉科技信息化投资项目管理及项目分析鉴别、信息化管理、科创体系建设工作。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 2,
          name: "投资发展部副部长",
          secondCompany: "湖北水利发展集团有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职级",
          needNum: 1,
          education: "本科",
          desc: "1.执行集团战略部署和公司党委、董事会决议；\n2.参与集团项目前期工作策划、项目立项审批或核准、可行性研究、投资管理、业务板块投资分析、投后评估管理等工作；\n3.参与集团业务拓展，与各级政府部门建立和维护好合作关系，负责与地方政府共同策划、推进合作项目；\n4.参与集团投资管理，制定集团投资管理制度，监督、指导与考核出资企业的投资管理等工作；\n5.参与编制并实施集团年度投资计划，建立投资项目库，协调调度重点投资项目和重要投资工作；\n6.参与开展投资项目的投后管理工作，监督投资决策落实情况；\n7.履行公司章程和董事会授予的其他职能职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.年龄原则上不超过40周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n3.近3年年度考核结果为胜任（称职）及以上；\n4.具有8年以上大型国企或行业龙头公司（含上市公司）投资相关从业经历；\n5.现任同级别党政机关、事业单位、科研院所、央国企中层副职等相当层级岗位，或下一层级中层正职等相当层级岗位任职3年以上，或累计5年以上下一层级中层正职及下一层级中层副职等相当层级岗位任职经历（下一层级中层正职经历不少于1年）；\n6.熟悉国家和地方水利行业相关政策法规、市场趋势以及行业内项目运作模式；具有丰富的政策研究、投资决策、项目投资管理等相关管理经验；\n7.同等条件下，持有注册咨询工程师（投资）等相关资格证书者优先；具有水利、水环境设施等相关项目投资全流程工作经历者优先。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 3,
          name: "总经理",
          secondCompany: "湖北水利发展集团十堰投资开发有限公司",
          third: "",
          dept: "",
          jobType: "集团中层正职级",
          needNum: 1,
          education: "本科",
          desc: "1.全面主持公司生产经营管理工作，组织实施集团董事会决议，对公司经营业绩和安全生产工作负总责；\n2.组织拟订并实施公司发展战略、年度经营计划和投资方案，聚焦十堰区域水利核心业务，推动项目落地见效；\n3.统筹公司水利工程项目全周期管理，负责项目前期、投融资、建设运营及成本管控，确保项目按期按质完成；\n4.负责与十堰市委市政府、行业主管部门、金融机构及合作单位的高层对接，争取政策资源，营造良好发展环境；\n5.建立健全公司内部管理体系，负责财务管理、资产保值增值、团队建设及人事管理，防范各类经营风险；\n6.统筹抓好安全生产、生态环保和社会责任工作；\n7.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.中共党员；\n3.年龄原则上不超过45周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n4.近3年年度考核结果为胜任（称职）及以上；\n5.具有10年及以上水利行业、投融资行业相关工作经验，熟悉国有企业经营管理模式，具备较强的市场开拓能力和经营业绩意识。\n6.现任同级别党政机关、事业单位、科研院所、央国企中层正职等相当层级岗位，或中层副职等相当层级岗位任职2年以上，或累计5年以上中层副职及下一层级中层正职等相当层级岗位任职经历（中层副职任职经历不少于1年）；\n7.具备良好的财务管理和风险管控能力，能够有效控制项目成本和经营风险，确保国有资产保值增值；\n8.具有水利、市政工程、市场开拓等相关工作经历者优先，熟悉市场情况和政府工作流程，具备良好的政府关系和资源整合能力。",
          location: "十堰区域",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 4,
          name: "总经理",
          secondCompany: "湖北瑞洪工程管理有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职级",
          needNum: 1,
          education: "本科",
          desc: "1.全面主持公司生产经营管理，组织实施董事会决议，对经营业绩和工程质量安全工作负总责；\n2.组织拟订并实施公司发展战略、年度经营计划和投资方案，聚焦水利工程监理、全过程咨询等核心业务，推动业务转型升级；\n3.统筹工程咨询项目全生命周期管理，负责项目承接、过程管控及成果交付，严控质量、进度与成本，维护公司资质与品牌信誉；\n4.负责市场拓展与资源整合，对接集团内外及政府、行业各方，构建客户网络，争取优质项目与政策支持；\n5.建立健全公司管理与质量保证体系，负责财务、人事及团队建设，防范经营、法律与廉政风险；\n6.落实工程质量安全监理责任，统筹抓好安全生产、质量管理与合规经营，杜绝重大质量安全事故；\n7.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.中共党员；\n3.年龄原则上不超过40周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n4.近3年年度考核结果为胜任（称职）及以上；\n5.具有8年以上水利工程监理、全过程工程咨询或工程建设管理等相关工作经验，熟悉工程监理、造价咨询、招标代理全流程运作；\n6.现任同级别党政机关、事业单位、科研院所、央国企中层副职等相当层级岗位，或下一层及中层正职等相当层级岗位任职3年以上，或累计5年以上下一层级中层正职及下一层级中层副职等相当层级岗位任职经历（下一层级中层正职经历不少于1年）；\n7.熟悉国有企业经营管理模式，具备较强的经营业绩意识和成本控制能力；\n8.熟悉工程咨询行业资质标准和维护要求，具备丰富的市场开拓和客户关系维护经验；\n9.具有行业相关专业技术高级及以上职称。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 5,
          name: "副总经理",
          secondCompany: "湖北水发汉江控股有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职级",
          needNum: 1,
          education: "本科",
          desc: "1.协助公司党委落实集团及汉江控股公司的重大决策事项；统筹分管业务板块经营管理工作，对分管领域的经营指标和安全生产工作负直接责任；\n2.参与制定公司涉水产业综合投资运营战略与年度经营计划，协助推动公司发展规划落地实施；\n3.协助负责公司水利工程项目的资源整合、项目拓展及市场化运营工作，牵头推进各类重点项目的实施与全流程管控，确保项目按期按质完成并实现预期效益；\n4.协助搭建公司实体化管控机制，分管内控制度建设、风险防控、团队管理及人才培养工作，保障公司规范高效运营；\n5.负责分管领域的政企对接、资源整合与合作洽谈，拓展业务渠道，维护政府部门、合作单位等关键关系，争取政策与项目支持；\n6.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.年龄原则上不超过40周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n3.近3年年度考核结果为胜任（称职）及以上；\n4.具有8年及以上水利、水务、市政工程或相关产业投资运营领域工作经验；\n5.现任同级别党政机关、事业单位、科研院所、央国企中层副职等相当层级岗位，或下一层及中层正职等相当层级岗位任职3年以上，或累计5年以上下一层级中层正职及下一层级中层副职等相当层级岗位任职经历（下一层级中层正职经历不少于1年）；\n6.熟悉区域水资源整合、城乡供排水一体化、水利建设、水环境治理等核心业务，具有主导或参与大型涉水投资项目经验；\n7.熟悉大型工程项目从前期谋划、立项审批、投融资运作、建设管理、市场化运营的全流程管理，有较强的成本控制和效益意识。",
          location: "襄阳区域",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 6,
          name: "副总经理",
          secondCompany: "湖北禹航物产有限责任公司",
          third: "",
          dept: "",
          jobType: "集团中层副职级",
          needNum: 1,
          education: "本科",
          desc: "1.协助公司党委落实集团及禹航公司的重大决策事项；\n2.协助总经理制定公司发展战略、年度经营计划与投资方案，聚焦水利物资供应链、贸易、仓储物流等核心业务，推动战略落地与经营目标达成；\n3.协助公司物资贸易、供应链运营、市场拓展等核心业务板块，组织开展商务谈判、渠道建设与客户关系管理，提升市场份额与盈利能力；\n4.审核把控公司重大项目全流程管理，负责项目立项、合作洽谈、风险评估及实施推进，保障项目合规、高效落地并实现预期收益；\n5.负责搭建与维护内外部资源网络，对接政府部门、金融机构、上下游合作伙伴，争取政策支持、资源倾斜与合作机会；\n6.协助总经理完善公司管理体系与制度建设，分管团队建设、绩效考核、人才培养及安全生产、合规风控工作，防范经营风险；\n7.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.年龄原则上不超过40周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n3.近3年年度考核结果为胜任（称职）及以上；\n4.具有8年及以上物资贸易、供应链管理、仓储物流等相关工作经验；\n5.现任同级别党政机关、事业单位、科研院所、央国企中层副职等相当层级岗位，或下一层及中层正职等相当层级岗位任职3年以上，或累计5年以上下一层级中层正职及下一层级中层副职等相当层级岗位任职经历（下一层级中层正职经历不少于1年）；\n6.熟悉物资采购、贸易、仓储、配送全流程运作，具有大型水利工程项目物资集中供应保障经验者优先；\n7.具有独立分管业务板块的全面管理经验，熟悉市场开拓、商务谈判、客户关系维护及渠道建设，有较强的经营业绩意识和市场开拓能力。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
        {
          id: 7,
          name: "副总经理",
          secondCompany: "湖北楚禹水务科技有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职级",
          needNum: 1,
          education: "本科",
          desc: "1.协助公司党委落实集团及楚禹公司的重大决策事项； \n2.协助总经理统筹公司经营管理，落实董事会各项决议，分管板块业务、安全及廉政相关工作；\n3.参与制定企业发展规划与年度经营目标，聚焦水务技术研发、智慧水务、水环境治理、节水科技等业务推进落地；\n4.分管科技项目、技术服务与工程业务，把控项目质量、进度、成本，保障项目规范高效运营；\n5.负责市场开拓、政企对接及产学研合作，拓展业务渠道，维护客户与行业资源；\n6.健全分管领域管理制度，抓好团队建设、人才培养、风控合规与资产管理工作；\n7.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.全日制本科及以上学历；\n2.年龄原则上不超过40周岁，身体健康，能够满足工作需要，特别优秀的年龄可适当放宽；\n3.近3年年度考核结果为胜任（称职）及以上；\n4.具有8年及以上水务、环保、水利工程或相关科技领域工作经验；\n5.现任同级别党政机关、事业单位、科研院所、央国企中层副职等相当层级岗位，或下一层及中层正职等相当层级岗位任职3年以上，或累计5年以上下一层级中层正职及下一层级中层副职等相当层级岗位任职经历（下一层级中层正职经历不少于1年）；\n6.熟悉智慧水务、水环境治理、节水技术、水务信息化等核心业务，主持或主导过相关工程项目、技术研发项目；\n7.具备较强的技术管理能力，熟悉水务科技项目从技术方案设计、实施到验收的全流程，能够有效把控项目质量、进度与成本。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=hbsf2026",
        },
      ],
    };
  },
  computed: {
    filteredJobs() {
      return this.jobList.filter((job) => {
        let isOk = true;
        if (this.selectedSecond)
          isOk = isOk && job.secondCompany === this.selectedSecond;
        if (this.selectedLocation)
          isOk = isOk && job.location.includes(this.selectedLocation);
        if (this.selectedEdu) isOk = isOk && job.education === this.selectedEdu;
        return isOk;
      });
    },
  },
  methods: {
    goLink(url) {
      if (url && url !== "#") window.open(url, "_blank");
    },
    toggleDetail(id) {
      const idx = this.openIds.indexOf(id);
      if (idx > -1) this.openIds.splice(idx, 1);
      else this.openIds.push(id);
    },
  },
};
</script>

<style scoped lang="less">
.job-page {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 15px;
  box-sizing: border-box;
}
.select-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.select-box {
  flex-shrink: 0;
  /deep/ .el-select {
    width: 100%;
    min-width: 200px;
    max-width: 260px;
  }
  /deep/ .el-input__inner {
    height: 44px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 15px;
    transition: all 0.2s;
  }
  /deep/ .el-select:hover .el-input__inner {
    border-color: #006699;
  }
  /deep/ .el-select:focus .el-input__inner {
    border-color: #006699;
    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);
  }
}
.job-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}
.job-item {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 86, 179, 0.06);
  border-left: 4px solid #006699;
  transition: transform 0.2s;
  cursor: pointer;
}
.job-item:hover {
  transform: translateY(-3px);
}
/* 头部：左右固定布局，不换行 */
.job-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}
.job-left {
  flex: 1;
  min-width: 0;
}
.job-name {
  font-size: 18px;
  font-weight: bold;
  color: #006699;
  margin-bottom: 8px;
}
.job-company {
  font-size: 14px;
  color: #333;
}
.apply-btn {
  flex-shrink: 0;
  /deep/ .el-button {
    background-color: #006699;
    border-color: #006699;
    border-radius: 6px;
  }
  /deep/ .el-button:hover {
    background-color: #005580;
    border-color: #005580;
  }
}
/deep/ .el-button [class*=el-icon-]+span {
  margin-left: 0;
}
.job-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
}
.info-item {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.desc-block {
  margin-top: 8px;
}
.desc-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
}
.arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
  transition: transform 0.2s;
}
.arrow.open {
  transform: rotate(180deg);
}
.desc-content {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
  margin-top: 6px;
}
.sub-title {
  font-weight: bold;
}
.empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #999;
  padding: 60px 0;
  font-size: 15px;
}

/* 移动端适配：头部布局保持左右结构，不换行 */
@media (max-width: 768px) {
  .job-page {
    padding: 15px 12px;
  }
  .select-row {
    flex-direction: column;
    align-items: stretch;
  }
  .select-box /deep/ .el-select {
    max-width: 100%;
  }
  .job-list {
    grid-template-columns: 1fr;
  }
  .job-item {
    padding: 18px;
  }
  .job-info {
    gap: 10px;
  }
}
</style>